import { http, HttpResponse } from 'msw';

export default {
    hurdlrAccessToken: http.get('*/hurdlr/user/', () => HttpResponse.json({ access_token: 'mock-token' })),
};
